export const ArrowRightCircleHovered = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12 2.46997C6.48 2.46997 2 6.94997 2 12.47C2 17.99 6.48 22.47 12 22.47C17.52 22.47 22 17.99 22 12.47C22 6.94997 17.52 2.46997 12 2.46997ZM16.03 13L13.03 16C12.88 16.15 12.69 16.22 12.5 16.22C12.31 16.22 12.12 16.15 11.97 16C11.68 15.71 11.68 15.23 11.97 14.94L13.69 13.22L8.5 13.22C8.09 13.22 7.75 12.88 7.75 12.47C7.75 12.06 8.09 11.72 8.5 11.72L13.69 11.72L11.97 9.99997C11.68 9.70997 11.68 9.22997 11.97 8.93997C12.26 8.64997 12.74 8.64997 13.03 8.93997L16.03 11.94C16.32 12.23 16.32 12.71 16.03 13Z" />
  </svg>
);
